import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Menu, Segment, Icon } from "semantic-ui-react"; // Import Icon
import "../../node_modules/react-vis/dist/style.css";
import "../css/home.css";
import "semantic-ui-css/semantic.min.css"; // Ensure this is correctly imported

import CompareResults from "../main/CompareResults";
import { UserContext } from "../main/MainHome.js";
import Constants from "../util/Constants";
import LoadingSpinner from "../util/LoadingSpinner";
import NoData from "../util/NoData";
import CompanyHeader from "./CompanyHeader";
import CompanyProfile from "./CompanyProfile";
import CompleteReport from "./CompleteReport";
import ETFProfile from "./ETFProfile";
import FACheckList from "./FACheckList";
import FA2Consolidated from "./FA2Consolidated";
import TA2Consolidated from "./TA2Consolidated";
import Financials from "./Financials";
import IntrinsicValue from "./IntrinsicValue";
import IntrsicAccVal from "./IntrsicAccVal";
import ScreenerContainer from "../main/ScreenerContainer";
import { isMobile } from "react-device-detect";

export default function CompanyPage(props) {
  const [stateValues, setStateValues] = useState({
    activeItem: "profile",
    stockValues: "",
    nodata: true,
    etf: false,
    compareResults: "",
    isFavorite: false,
    loading: true,
    portfolio: null,
  });

  const userEmail = useContext(UserContext);

  useEffect(() => {
    setStateValues({ ...stateValues, loading: true });

    var urlVal =
      Constants.SERVICE_URL +
      "?userEmail=" +
      userEmail +
      "&symbol=" +
      props.symbol;

    axios({
      method: "get",
      responseType: "json",
      url: urlVal,
    })
      .then((response) => {
        const calStkVal = response.data?.calStkVal;
        setStateValues({
          stockValues: calStkVal,
          scoreRadar: response.data?.scoreRadar || null,
          scoreAudit: response.data?.scoreAudit || null,
          activeItem: calStkVal
            ? calStkVal.compProfile?.etf === true
              ? "etf"
              : "profile"
            : "profile",
          nodata: calStkVal?.notEnoughData ?? true,
          etf: calStkVal?.compProfile?.etf ?? false,
          isFavorite: response.data?.isFavorite ?? false,
          compareResults: response.data?.compareResults ?? "",
          portfolio: response.data?.portfolio ?? null,
          loading: false,
        });
      })
      .catch(function (error) {
        console.error("Home: Company Page response Error:", error);
        setStateValues((prev) => ({ ...prev, loading: false, nodata: true }));
      });
  }, [props.symbol]);

  let seg = "";

  if (stateValues.activeItem === "profile") {
    seg = (
      <div style={{ marginTop: "0", marginLeft: "0px", marginRight: "0px" }}>
        <CompanyProfile
          userEmail={userEmail}
          stockValues={stateValues.stockValues}
          scoreRadar={stateValues.scoreRadar}
          onNavigateToBeta={() => handleItemClick(null, { name: "fundamentals2" })}
        />
      </div>
    );
  } else if (stateValues.activeItem === "intrinsic") {
    let content = <NoData />;
    let intrinsicVal = "";
    if (!stateValues.nodata) {
      intrinsicVal = <IntrinsicValue stockValues={stateValues.stockValues} />;
      content = <IntrsicAccVal stockValues={stateValues.stockValues} />;
    }
    seg = (
      <div style={{ marginTop: "4px", marginLeft: "0px", marginRight: "0px" }}>
        {intrinsicVal} {content}
      </div>
    );
  } else if (stateValues.activeItem === "financials") {
    let content = <NoData />;
    if (!stateValues.nodata) {
      content = <Financials stockValues={stateValues.stockValues} />;
    }
    seg = (
      <div style={{ marginTop: "10px", marginLeft: "0px", marginRight: "0px" }}>
        {content}
      </div>
    );
  } else if (stateValues.activeItem === "fundamentals") {
    let content = <NoData />;
    if (!stateValues.nodata) {
      content = <FACheckList stockValues={stateValues.stockValues} />;
    }
    seg = <>{content}</>;
  } else if (stateValues.activeItem === "fundamentals2") {
    let content = <NoData />;
    if (!stateValues.nodata) {
      content = (
        <FA2Consolidated stockValues={stateValues.stockValues} scoreAudit={stateValues.scoreAudit} />
      );
    }
    seg = <>{content}</>;
  } else if (stateValues.activeItem === "technical") {
    let content = <NoData />;
    if (!stateValues.nodata) {
      content = <TA2Consolidated stockValues={stateValues.stockValues} />;
    }
    seg = <>{content}</>;
  } else if (stateValues.activeItem === "complete") {
    let content = <NoData />;
    if (!stateValues.nodata) {
      content = (
        <CompleteReport
          stockValues={stateValues.stockValues}
          compareResults={stateValues.compareResults}
          userEmail={userEmail}
        />
      );
    }
    seg = (
      <div
        style={{
          marginTop: "14px",
          marginLeft: isMobile ? "0px" : "5px",
          marginRight: isMobile ? "0px" : "5px",
        }}
      >
        {content}
      </div>
    );
  } else if (stateValues.activeItem === "peers") {
    if (!stateValues.nodata) {
      seg = (
        <div
          style={{ marginTop: "0rem", marginLeft: "5px", marginRight: "5px" }}
        >
          <CompareResults
            stckLst={stateValues.compareResults}
            userEmail={userEmail}
          />
        </div>
      );
    } else {
      seg = (
        <Segment>
          <NoData />
        </Segment>
      );
    }
  } else if (stateValues.activeItem === "etf") {
    seg = (
      <div style={{ marginTop: "-1rem" }}>
        <ETFProfile
          userEmail={userEmail}
          stockValues={stateValues.stockValues}
        />
      </div>
    );
  } else if (stateValues.activeItem === "holdings") {
    seg = (
      <Segment>
        <ScreenerContainer
          userEmail={userEmail}
          portfolio={stateValues.portfolio}
          screenerTitle={stateValues.portfolio?.name}
          screenerTitle={stateValues.portfolio?.name}
        />
      </Segment>
    );
  }

  // ** Function to tab selection
  function handleItemClick(e, { name }) {
    setStateValues({ ...stateValues, activeItem: name });
  }

  return stateValues.loading ? (
    <LoadingSpinner />
  ) : stateValues.stockValues ? (
    <div
      style={{
        marginBottom: "80px",
        width: "100%",
        padding: 0,
        margin: 0,
      }}
    >
      {!stateValues.etf ? (
        <Menu
          tabular
          unstackable
          className="company-page-menu"
          style={{
            backgroundColor: "#2B3856",
            whiteSpace: "nowrap",
            display: "flex",
            margin: 0,
            padding: 0,
            width: "100%",
            ...(!stateValues.etf && {
              overflowX: "auto",
              overflowY: "hidden",
            }),
          }}
          inverted
        >
          <Menu.Item
            name="profile"
            active={stateValues.activeItem === "profile"}
            onClick={handleItemClick}
          >
            <Icon name="info circle" />
            <span className="mobile hidden">Company Details</span>
            {/* Hide text on mobile */}
          </Menu.Item>
          <Menu.Item
            name="intrinsic"
            active={stateValues.activeItem === "intrinsic"}
            onClick={handleItemClick}
          >
            <Icon name="dollar" />
            <span className="mobile hidden">Intrinsic Value</span>
          </Menu.Item>
          <Menu.Item
            name="financials"
            active={stateValues.activeItem === "financials"}
            onClick={handleItemClick}
          >
            <Icon name="book" />
            <span className="mobile hidden">Financials</span>
          </Menu.Item>
          <Menu.Item
            name="fundamentals"
            active={stateValues.activeItem === "fundamentals"}
            onClick={handleItemClick}
          >
            <Icon name="tasks" />
            <span className="mobile hidden">Fundamental Analysis</span>
          </Menu.Item>
          <Menu.Item
            name="fundamentals2"
            active={stateValues.activeItem === "fundamentals2"}
            onClick={handleItemClick}
          >
            <Icon name="list ul" />
            <span className="mobile hidden">Fundamentals Analysis (Beta)</span>
          </Menu.Item>
          <Menu.Item
            name="technical"
            active={stateValues.activeItem === "technical"}
            onClick={handleItemClick}
          >
            <Icon name="chart line" />
            <span className="mobile hidden">Technical Analysis (Beta)</span>
          </Menu.Item>
          <Menu.Item
            name="complete"
            active={stateValues.activeItem === "complete"}
            onClick={handleItemClick}
          >
            <Icon name="file alternate" />
            <span className="mobile hidden">Complete Report</span>
          </Menu.Item>
          <Menu.Item
            name="peers"
            active={stateValues.activeItem === "peers"}
            onClick={handleItemClick}
          >
            <Icon name="exchange" />
            <span className="mobile hidden">Compare to Peers</span>
          </Menu.Item>
        </Menu>
      ) : (
        <Menu
          unstackable
          tabular
          className="company-page-menu" // Add custom class here
          style={{
            backgroundColor: "#2B3856",
            whiteSpace: "nowrap",
            display: "flex",
            ...(stateValues.etf && {
              overflowX: "auto",
              overflowY: "hidden",
            }),
          }}
          inverted
          pointing
        >
          <Menu.Item
            name="etf"
            active={stateValues.activeItem === "etf"}
            onClick={handleItemClick}
          >
            <Icon name="chart pie" />
            <span className="mobile hidden">ETF Details</span>
          </Menu.Item>
          <Menu.Item
            name="holdings"
            active={stateValues.activeItem === "holdings"}
            onClick={handleItemClick}
          >
            <Icon name="building outline" />
            <span className="mobile hidden">Stock Holdings</span>
          </Menu.Item>
        </Menu>
      )}
      <div
        style={{
          marginTop: "2px",
          marginLeft: 0,
          marginRight: 0,
          padding: 0,
          width: "100%",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        {stateValues.stockValues &&
          (isMobile &&
          (stateValues.activeItem === "profile" ||
            stateValues.activeItem === "etf") ? (
            <CompanyHeader
              userEmail={userEmail}
              stockValues={stateValues.stockValues}
              isFavorite={stateValues.isFavorite}
              onFavoriteChange={(isFavorite) => setStateValues((prev) => ({ ...prev, isFavorite }))}
              onStampClick={() => handleItemClick(null, { name: "fundamentals2" })}
              onTechnicalStampClick={() => handleItemClick(null, { name: "technical" })}
              onFairValueClick={() => handleItemClick(null, { name: "intrinsic" })}
            />
          ) : (
            !isMobile && (
              <CompanyHeader
                userEmail={userEmail}
                stockValues={stateValues.stockValues}
                isFavorite={stateValues.isFavorite}
                onFavoriteChange={(isFavorite) => setStateValues((prev) => ({ ...prev, isFavorite }))}
                onStampClick={() => handleItemClick(null, { name: "fundamentals2" })}
                onTechnicalStampClick={() => handleItemClick(null, { name: "technical" })}
                onFairValueClick={() => handleItemClick(null, { name: "intrinsic" })}
              />
            )
          ))}
      </div>
      {seg}
    </div>
  ) : stateValues.nodata && !stateValues.loading ? (
    <Segment>
      <NoData />
    </Segment>
  ) : null;
}
